import React from 'react'

import WhcLogoWhite from "../assets/images/whc_logo_white.png";
import logoLightFull from "../assets/images/logo-light.png";
import authEffect2 from "../assets/images/effect-pattern/auth-effect-2.png";
import authEffect from "../assets/images/effect-pattern/auth-effect.png";
import usecustomStyles from './customStyles';
import { HeartFilled } from '@ant-design/icons';
import { Col } from 'antd';

const customStyles = usecustomStyles();

const ParticleAuth = () => {
    return (
        <React.Fragment>
                <Col xs={24} lg={10} style={{ backgroundColor: customStyles.colorPrimary, color: customStyles.colorBgContainer, borderRadius: '6px' }}>
                    <div style={{ display: 'flex', flexDirection: "column", alignItems: "space-between", padding: "20px", justifyContent:'space-between', height:'100%' }}>
                        <div style={{ marginBottom: "30px" }}>
                        </div>

                        <div>
                            <h3 style={{ fontSize: "22px", fontWeight: "bold" }}>Direktor</h3>
                            <img src={WhcLogoWhite} alt="" height="100" />

                            <p><small>It brings together your finances</small></p>
                        </div>
                        <div className="text-center text-white-75">
                        </div>
                    </div>
                </Col>
        </React.Fragment>
    )
}

export default ParticleAuth
